module.exports = __webpack_public_path__ + "static/media/image02.518c9d53.webp";